<template>
  <Modal :id="'cmp-add-currency'" @cancelled="onCancel" :loadingFlag="loading">
    <template slot="header">
      Add {{ $t("currency") }}
    </template>
    <template slot="body">
      <div class="form-group">
        <TextField
          class="m1"
          :id="'currency_iso'"
          required
          v-bind="textFieldConfig"
          v-model="currency_iso"
          isModel
          :placeholder="$t('currency_iso')"
        ></TextField>
        <TextField
          class="m1"
          :id="'currency_name'"
          required
          v-bind="textFieldConfig"
          v-model="currency_name"
          isModel
          :placeholder="$t('currency_name')"
        ></TextField>
        <TextField
          class="m1"
          :id="'exchange_rate'"
          v-bind="textFieldConfig"
          v-model="exchange_rate"
          isModel
          :placeholder="$t('exchange_rate')"
        ></TextField>
      </div>
    </template>
    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">
        {{ $t("cancel") }}
      </button>
      <button class="dt-button v1 with-ico s1" @click.stop="onAddcurrency">
        <div class="dt-icon-container">
          <img src="static/icons/plus-white.svg" class="dt-icon v7" alt />
        </div>
        <div class="button-text">
          {{ $t("add") }} {{ $t("new") }} {{ $t("currency") }}
        </div>
      </button>
    </template>
  </Modal>
</template>

<script>
import Modal from "@dtplugins/modal/modal";
import { GeneralSettingService } from "../../services/general-settings.service";

export default {
  components: {
    Modal
  },
  props: {},
  data: function() {
    return {
      loading: false,

      currency_iso: "",
      currency_name: "",
      exchange_rate: "",

      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false
      }
      // Mark: Data
    };
  },
  watch: {},
  computed: {
    currency: function() {
      return {
        currency_iso: this.currency_iso,
        currency_name: this.currency_name,
        exchange_rate: this.exchange_rate
      };
    }
  },
  methods: {
    onCancel: function() {
      this.$emit("cancelled", true);
    },
    onAddcurrency: async function() {
      this.loading = true;
      const newCurr = await GeneralSettingService.insertNewCurrency({
        ...this.currency
      });

      const currencies = await GeneralSettingService.findCurrencies();

      this.$emit("added", currencies.data);
    }
    // Mark: Methods
  }
};
</script>

<style lang="scss" scoped>
.dt-button.with-ico {
  padding: 0 3px 0 0;
}
// .ckeditor-container {
//   .ck-editor {
//     width: 100%;
//   }

// }

.dt-input-box--container {
  // margin: 5px !important;
  // margin-left: 0px !important;
}
</style>
